'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noop = function noop() {};

var getNodes = function getNodes(props) {
  var nodeById = props.id && document.getElementById(props.id);
  var nodesById = nodeById ? [nodeById] : [];
  var nodesBySelector = props.selector && [].slice.call(document.querySelectorAll(props.selector)) || [];

  return nodesById.concat(nodesBySelector);
};

var ElementPortal = function (_React$Component) {
  _inherits(ElementPortal, _React$Component);

  function ElementPortal(props) {
    _classCallCheck(this, ElementPortal);

    var _this = _possibleConstructorReturn(this, (ElementPortal.__proto__ || Object.getPrototypeOf(ElementPortal)).call(this, props));

    _this.state = {
      mounted: false
    };
    _this.originalNodes = [];
    return _this;
  }

  _createClass(ElementPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      getNodes(this.props).forEach(function (node) {
        var clone = node.cloneNode(false);
        _this2.originalNodes.push(node);

        node.parentNode.replaceChild(clone, node);
      });

      this.setState({
        mounted: true
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      getNodes(this.props).forEach(function (node) {
        var el = _this3.originalNodes.pop();

        node.parentNode.replaceChild(el, node);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (!this.state.mounted) {
        return null;
      }

      var nodes = getNodes(this.props);
      var mapDomNodeToProps = this.props.mapDomNodeToProps || noop;

      return nodes.map(function (node, i) {
        if (_this4.props.shouldReset) {
          node.className = '';
          node.removeAttribute('style');
        }

        var View = _this4.props.view;

        var children = View ? _react2.default.createElement(View, mapDomNodeToProps(_this4.originalNodes[i])) : _react2.default.Children.only(_this4.props.children);

        return _reactDom2.default.createPortal(children, node);
      });
    }
  }]);

  return ElementPortal;
}(_react2.default.Component);

ElementPortal.propTypes = {
  id: _propTypes2.default.string,
  selector: _propTypes2.default.string,
  mapDomNodeToProps: _propTypes2.default.func,
  // Remove styles and classes from node.
  shouldReset: _propTypes2.default.bool,
  view: _propTypes2.default.func
};
exports.default = ElementPortal;